import React, { Component } from 'react'
import PropTypes from 'prop-types'
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup'

import './CurtainsScene.scss'

export default class CurtainsScene extends Component {

  render () {
    const { bg, text1, text2, visible } = this.props
    return (
      <CSSTransitionGroup
        transitionName='aw_curtains'
        transitionEnterTimeout={2500}
        transitionLeaveTimeout={1450}
      >
        {visible &&
          <div className='aw_curtains'>
            <div className='aw_curtains__door-wrap aw_curtains__door-wrap--left'>
              <div
                className='aw_curtains__door-left'
                style={{ backgroundImage: `url(${bg})` }} />
            </div>
            <div className='aw_curtains__door-wrap aw_curtains__door-wrap--right'>
              <div
                className='aw_curtains__door-right'
                style={{ backgroundImage: `url(${bg})` }} />
            </div>

            <div id='aw_curtains__bg' className='aw_curtains__bg' style={{ backgroundImage: `url(${bg})` }} />

            <div className='aw_curtains__content'>
              <div id='aw_curtains__text1' className='aw_curtains__text aw_curtains__text--1'>
                {text1}
              </div>
              <div id='aw_curtains__text2' className='aw_curtains__text aw_curtains__text__2 aw_curtains__text--2'>
                {text2}
              </div>
            </div>
          </div>
        }
      </CSSTransitionGroup>
    )
  }

  static propTypes = {
    bg: PropTypes.string,
    text1: PropTypes.string,
    text2: PropTypes.string,
    visible: PropTypes.bool
  }
}



// WEBPACK FOOTER //
// ./src/templates/app-website/components/curtains/CurtainsScene.js